import { IWidgetProps } from "decorator-form";
import React from "react";

import IOption from "common/models/IOption";
import ButtonSelect from "./common/ButtonSelect";

export enum Directions {
	UP = "to top",
	RIGHT = "to right",
	DOWN = "to bottom",
	LEFT = "to left",
	UP_LEFT = "to top left",
	UP_RIGHT = "to top right",
	DOWN_RIGHT = "to bottom right",
	DOWN_LEFT = "to bottom left"
}

const options: IOption[] = [
	{ value: Directions.UP, label: "Top" },
	{ value: Directions.RIGHT, label: "Right" },
	{ value: Directions.DOWN, label: "Bottom" },
	{ value: Directions.LEFT, label: "Left" },
	{ value: Directions.UP_LEFT, label: "Top Left" },
	{ value: Directions.UP_RIGHT, label: "Top Right" },
	{ value: Directions.DOWN_RIGHT, label: "Bottom Right" },
	{ value: Directions.DOWN_LEFT, label: "Bottom Left" }
];

const DirectionWidget: React.SFC<IWidgetProps<string>> = (props) => {
	return <ButtonSelect {...props} options={options} />;
};

export default DirectionWidget;



// WEBPACK FOOTER //
// ./src/common/form/widgets/DirectionWidget.tsx